var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDestination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5_10257",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0C4.7012 0 0 4.7012 0 10.5C0 16.2981 4.7012 21 10.5 21C16.2995 21 21 16.2981 21 10.5C21 4.7012 16.2995 0 10.5 0Z",
    fill: "#F58B7F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5_10257)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0C4.7012 0 0 4.7012 0 10.5C0 16.2981 4.7012 21 10.5 21C16.2995 21 21 16.2981 21 10.5C21 4.7012 16.2995 0 10.5 0Z",
    fill: "#0270B2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.90002C7.4073 4.90002 4.89999 7.40733 4.89999 10.5C4.89999 13.5923 7.4073 16.1 10.5 16.1C13.5931 16.1 16.1 13.5923 16.1 10.5C16.1 7.40733 13.5931 4.90002 10.5 4.90002V4.90002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7.70001C8.95365 7.70001 7.7 8.95367 7.7 10.5C7.7 12.0462 8.95365 13.3 10.5 13.3C12.0465 13.3 13.3 12.0462 13.3 10.5C13.3 8.95367 12.0465 7.70001 10.5 7.70001V7.70001Z",
    fill: "#0270B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestination);
export default __webpack_public_path__ + "static/media/destination.9bfd36709ea8249ab87e491f0d75b89b.svg";
export { ForwardRef as ReactComponent };